export function formatGraphTimeRangeLabel(startTime, endTime) {
  try {
    const fmt = new Intl.DateTimeFormat([], {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
    if (!startTime || !endTime) return null;
    return `${fmt.format(new Date(startTime))} – ${fmt.format(new Date(endTime))}`;
  } catch {
    return null;
  }
}